<app-driveb-option-menu
  [options]="options"
  [positionTooltip]="positionTooltip"
  [tooltip]="tooltipValue"
  [fontIcon]="fontIcon"
  (onClickItem)="downloadTemplate($event)"
  [disabled]="disabled || !options.length"
></app-driveb-option-menu>
